import { Grid, Typography } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

export default function ExpressOrderTimeLimitLabel({ timeUntil }) {
  return (
    <Grid
      container
      alignItems="center"
      wrap="nowrap"
      columnGap={1}
      minWidth={0}
    >
      <Grid item>
        <AccessTimeIcon sx={{ color: 'text.secondary' }} />
      </Grid>
      <Grid item zeroMinWidth>
        <Typography variant="body2" color="text.secondary" fontSize={12} noWrap>
          Entregar antes
        </Typography>
        <Typography
          variant="body2"
          color="text.secondary"
          fontWeight="bold"
          fontSize={12}
          noWrap
        >
          {timeUntil} hrs
        </Typography>
      </Grid>
    </Grid>
  );
}
